/*
 * @Author: M.D.
 * @Date: 2019-12-09 10:24:26
 * @LastEditors: M.D.
 * @Description:
 * @Remarks:
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import vstore from '../store'
import _ from 'lodash'

Vue.use(VueRouter)

const routes = [{
    path: '/WXPay', // 在线支付
    name: 'WXPay',
    meta: {
      requireAuth: true,
      title: '在线支付'
    },
    component: () => import( /* webpackChunkName: "user-info" */ '@/views/Order/WXPay.vue')

  },

  // 机器人登录
  {
    path: '/robotLogin',
    name: 'robotLogin',
    meta: {
      requireAuth: false,
      title: '机器人'
    },
    component: () => import( /* webpackChunkName: "index" */ '@/views/Robot/login.vue')
  },

  // 产品即将上线页
  {
    path: '/cpjjsx',
    name: 'cpjjsx',
    meta: {
      requireAuth: false,
      title: '产品即将上线'
    },
    component: () => import( /* webpackChunkName: "index" */ '@/views/other/index')
  },


  // 云平台登录注册
  {
    path: '/cloudLogin',
    name: 'cloudLogin',
    meta: {
      requireAuth: false,
      title: '云平台'
    },
    component: () => import( /* webpackChunkName: "index" */ '@/views/Login/cloud-login.vue')
  },
  {
    path: '/',
    name: 'base',
    meta: {
      requireAuth: false
    },
    component: () => import( /* webpackChunkName: "index" */ '@/views/Index/base.vue'),
    redirect: {
      name: 'index'
    },
    children: [
      // 首页
      {
        path: 'index/:productId?/:type?',
        name: 'index',
        meta: {
          requireAuth: false,
          title: '首页'
        },
        component: () => import( /* webpackChunkName: "index" */ '@/views/Index/index.vue')
      },
      // 首页head页面，商品详情
      {
        path: 'product',
        name: 'product',
        meta: {
          requireAuth: false
        },
        component: () => import( /* webpackChunkName: "product" */ '@/layout/product.vue'),
        redirect: {
          name: 'qyfw'
        },
        children: [
          // 企业服务
          {
            path: 'qyfw',
            name: 'qyfw',
            meta: {
              requireAuth: false,
              title: '企业服务'
            },
            component: () => import( /* webpackChunkName: "product" */ '@/views/Products/qyFwpx.vue')
          },
          // 企业培训
          {
            path: 'qypx',
            name: 'qypx',
            meta: {
              requireAuth: false,
              title: '企业培训'
            },
            component: () => import( /* webpackChunkName: "product" */ '@/views/Products/qyFwpx.vue')
          },
          // 商品分类
          {
            path: '/category',
            name: 'category',
            meta: {
              requireAuth: false,
              title: '商品详情'
            },
            component: () => import( /* webpackChunkName: "product" */ '@/views/Products/category.vue')
          },
          // 最新资讯
          {
            path: '/news',
            name: 'news',
            meta: {
              requireAuth: false,
              title: '最新资讯'
            },
            component: () => import( /* webpackChunkName: "product" */ '@/views/News/news-list.vue')
          },
          // 资讯详情
          {
            path: '/news/:newsId',
            name: 'news-detail',
            meta: {
              requireAuth: false,
              title: '资讯详情'
            },
            component: () => import( /* webpackChunkName: "product" */ '@/views/News/news-detail.vue')
          },
          // 商品详情
          {
            path: '/product/:prodId/:type?/',
            name: 'productDetail',
            meta: {
              requireAuth: false,
              title: '商品详情'
            },
            component: () => import( /* webpackChunkName: "product" */ '@/views/Products/prdDetail.vue')
          },
          //视频播放
          {
            path: '/productvideo/:prodId/:type?/',
            name: 'productvideo',
            meta: {
              requireAuth: false,
              title: '商品详情'
            },
            component: () => import( /* webpackChunkName: "product" */ '@/views/Products/playvideo.vue')
          },
          // 订单确认
          {
            path: '/orderConfirm/:prodId/:freeQuota?',
            name: 'orderConfirm',
            meta: {
              requireAuth: true,
              title: '订单确认'
            },
            component: () => import( /* webpackChunkName: "product" */ '@/views/Order/submitOrder.vue')
          },
          // 税筹获取信息  lyj
          {
            path: '/taxDecision/:prodId/:freeQuota?',
            name: 'taxDecision',
            meta: {
              requireAuth: true,
              title: '税收筹划'
            },
            component: () => import( /* webpackChunkName: "product" */ '@/views/Order/taxdecision.vue')
          },
          // 订单详情
          {
            path: '/orderDetail/:orderId/:isOnTrain?',
            name: 'orderDetail',
            meta: {
              requireAuth: true,
              title: '订单详情'
            },
            component: () => import( /* webpackChunkName: "order" */ '@/views/Order/order-detail.vue')
          },
          {
            path: '/evaluate', // 商品评价
            name: 'evaluate',
            meta: {
              requireAuth: true,
              title: '商品评价'
            },
            component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/evaluate.vue')
          },
          // 支付二维码
          {
            path: '/order/payQRCode',
            name: 'payQRCode',
            meta: {
              requireAuth: true,
              title: '扫码支付'
            },
            component: () => import( /* webpackChunkName: "order" */ '@/views/Order/pay-qrcode.vue')
          },
          // 支付(积分兑换)结果
          {
            path: '/order/payRes',
            name: 'result',
            meta: {
              requireAuth: true,
              title: '订单提交'
            },
            component: () => import( /* webpackChunkName: "order" */ '@/views/Order/sub-result.vue')
          },
          // 用户信息
          {
            path: '/userIndex',
            name: 'userIndex',
            meta: {
              requireAuth: true
            },
            component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/index.vue'),
            redirect: '/user',
            children: [{
                path: '/user', // 个人中心
                name: 'user',
                meta: {
                  requireAuth: true,
                  title: '个人中心'
                },
                component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/userCenter.vue')
              }, {
                path: '/userVipPrd', // 个人中心
                name: 'userVipPrd',
                meta: {
                  requireAuth: true,
                  title: '个人中心'
                },
                component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/userVipPrd.vue')
              }, {
                path: '/userInfo', // 个人信息
                name: 'userInfo',
                meta: {
                  requireAuth: true,
                  title: '个人信息'
                },
                // 查看跳转路由
                beforeEnter: (to, from, next) => {
                  // 保存路由名字，方便跳转回去
                  let orderConfirmName = from.name
                  // 保存完整路径
                  let orderConfirmFullPath = from.fullPath
                  sessionStorage.setItem("orderConfirmName", orderConfirmName)
                  sessionStorage.setItem("orderConfirmFullPath", orderConfirmFullPath)
                  next()
                },
                component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/userInfo.vue')
              }, {
                path: '/message', // 我的消息
                name: 'message',
                meta: {
                  requireAuth: true,
                  title: '我的消息'
                },
                component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/message.vue')
              },


              {
                path: '/declare', // 申报
                name: 'declare',
                meta: {
                  requireAuth: true,
                  title: '申报信息'
                },
                component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/declare.vue')
              },

              {
                path: '/risk', // 风险评估
                name: 'risk',
                meta: {
                  requireAuth: true,
                  title: '风险评估'
                },
                component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/risk.vue')
              },



              {
                path: '/invoice', // 我的发票
                name: 'invoice',
                meta: {
                  requireAuth: true,
                  title: '我的发票'
                },
                component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/invoice.vue')
              },
              {
                path: '/mypoint', // 我的积分
                name: 'mypoint',
                meta: {
                  requireAuth: true,
                  title: '我的积分'
                },
                component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/myPoint.vue')
              }, {
                path: '/password', // 修改密码
                name: 'password',
                meta: {
                  requireAuth: true,
                  title: '修改密码'
                },
                component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/password.vue')
              }, {
                path: '/recommend', // 我的推荐
                name: 'recommend',
                meta: {
                  requireAuth: true,
                  title: '我的推荐'
                },
                component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/recommend.vue')
              }, {
                path: '/orders', // 我的订单
                name: 'orders',
                meta: {
                  requireAuth: true,
                  title: '我的订单'
                },
                component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/myOrder.vue')
              }, {
                path: '/qa', // 常见问题
                name: 'qa',
                meta: {
                  title: '常见问题'
                },
                component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/qAndA.vue')
              }, {
                path: '/qaDetail', //
                name: 'qaDetail',
                meta: {
                  title: '问题详情'
                },
                component: () => import( /* webpackChunkName: "user-info" */ '@/views/User/qaDetail.vue')
              }
            ]
          }
        ]
      },
      {
        path: '/orderPay', // 在线支付
        name: 'orderPay',
        meta: {
          requireAuth: true,
          title: '在线支付'
        },
        component: () => import( /* webpackChunkName: "user-info" */ '@/views/Order/orderPay.vue')
      },
      {
        path: '/payResult', // 支付结果
        name: 'payResult',
        meta: {
          requireAuth: true,
          title: '支付结果'
        },
        component: () => import( /* webpackChunkName: "user-info" */ '@/views/Order/payResult.vue')
      }
    ]
  }

  // 404页面
  // {
  //   path: '/pageNotFound',
  //   alias: '*',
  //   name: 'pageNotFound',
  //   alias: '*',
  //   component: () => import(/* webpackChunkName: "other" */ '@/views/other/404.vue')
  // }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | 企业服务平台`
  if (to.name === 'WXPay') {
    next()
  } else {
    if (_.isEmpty(vstore.state.user.userInfo) && to.meta.requireAuth) {
      next({
        name: 'base',
        query: {
          shm: 1,
          from: to.name
        }
      })
    } else {
      next()
    }
  }
})

export default router
